import { render, staticRenderFns } from "./JudicialRecoveryEnterprisePage.vue?vue&type=template&id=32524757&scoped=true"
import script from "./JudicialRecoveryEnterprisePage.vue?vue&type=script&lang=js"
export * from "./JudicialRecoveryEnterprisePage.vue?vue&type=script&lang=js"
import style0 from "./JudicialRecoveryEnterprisePage.vue?vue&type=style&index=0&id=32524757&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32524757",
  null
  
)

export default component.exports